import { defineStore } from 'pinia';
import http from '../store/helpers/http-common';
import { SHOPWARE_BASE_URL } from '../../utils/configure-environment';

export const useProductInfoStore = defineStore('product-info', {
  state: () => ({
    htmlContent: ''
  }),
  actions: {
    async fetchProductInfo(articleNumber) {
      const url = `${SHOPWARE_BASE_URL}/widgets/ProductDescription/index/number/${articleNumber}`;
      try {
        const response = await http.get(url);
        this.htmlContent = response.data;
        // this.$nextTick(() => {
        //   window.StateManager &&
        //     window.StateManager.addPlugin('.tab-menu--product', 'swTabMenu', [
        //       's',
        //       'm',
        //       'l',
        //       'xl'
        //     ]);
        // });
      } catch (error) {
        this.htmlContent = '';
      }
    }
  }
});
